import PropTypes from "prop-types";
import countryType from "./country.type";

export default PropTypes.shape({
	team1: countryType,
	team2: countryType
});
